import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';
import { Country } from './Country';

export class DemoPlan {
  id: number;
  name: string;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }

  static fromJson(json: Record<string, any>): DemoPlan {
    return plainToInstance(DemoPlan, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class DemoIndustry {
  id: number;
  name: string;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }

  static fromJson(json: Record<string, any>): DemoIndustry {
    return plainToInstance(DemoIndustry, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class DemoRequest {
  @Type(() => Country)
  countries: Country[];

  @Expose({ name: 'compensation_plans' })
  @Type(() => DemoPlan)
  plans: DemoPlan[];

  @Type(() => DemoIndustry)
  industries: DemoIndustry[];

  constructor(
    countries: Country[],
    plans: DemoPlan[],
    industries: DemoIndustry[]
  ) {
    this.countries = countries;
    this.plans = plans;
    this.industries = industries;
  }

  static fromJson(json: Record<string, any>): DemoRequest {
    return plainToInstance(DemoRequest, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
